var _require = require('prettier/standalone'),
    _require$doc$builders = _require.doc.builders,
    concat = _require$doc$builders.concat,
    group = _require$doc$builders.group,
    indent = _require$doc$builders.indent,
    join = _require$doc$builders.join,
    line = _require$doc$builders.line,
    softline = _require$doc$builders.softline;

var TupleExpression = {
  // @TODO: remove hack once solidity-parser-antlr is fixed
  print: function print(_ref) {
    var node = _ref.node,
        path = _ref.path,
        _print = _ref.print;
    return group(concat([node.isArray ? '[' : '(', indent(concat([softline, join(concat([',', line]), path.map(_print, node.components ? 'components' : 'elements'))])), softline, node.isArray ? ']' : ')']));
  }
};
module.exports = TupleExpression;